import { Button, DatePicker, Spin } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import { api, endpoint } from "@/api";
import appConfig from "@/config/appConfig";
import { CommonSelect } from "@/components/Common/CommonSelect";
import { flare } from "@flareapp/js";

const AssigPlan = () => {
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const [plans, setPlans] = useState([]);
  const [businessList, setBusinessList] = useState([]);
  const [isBusinessLoading, setIsBusinessLoading] = useState(false);
  const [assignPlanInput, setAssignPlanInput] = useState(defaultState);
  const navigate = useNavigate();

  const getPlan = async () => {
    try {
      const {
        data: { result },
      } = await axios.get(`/subscription`, {
        withCredentials: true,
      });
      setPlans(result);
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };
  const getBusiness = async () => {
    setIsBusinessLoading(true);
    try {
      const data = await api.get(endpoint.business);
      setBusinessList(data?.data);
    } finally {
      setIsBusinessLoading(false);
    }
  };
  const onNumberInputChange = (e) => {
    let { value, name } = e.target;
    value = value.replace(/\D/g, "");
    if (value) value = Number(value);
    setAssignPlanInput({
      ...assignPlanInput,
      [name]: value,
    });
  };
  const onInputChange = (e) => {
    if (e.target.name === "smsNotificationType") {
      const obj = { smsNotificationType: e.target.value, smsCount: "" };
      setAssignPlanInput({
        ...assignPlanInput,
        ...obj,
      });
    } else {
      setAssignPlanInput({
        ...assignPlanInput,
        [e.target.name]: e.target.value,
      });
    }
  };

  // let isDisable =
  //   !assignPlanInput?.business ||
  //   !assignPlanInput?.plan ||
  //   !assignPlanInput.duration ||
  //   !assignPlanInput.startDate ||
  //   !assignPlanInput.smsNotificationType;

  // console.log(assignPlanInput);

  const onUpdateCustomerPlan = async () => {
    let data = {
      ...assignPlanInput,
      startDate: assignPlanInput.startDate.toDate(),
      endDate: assignPlanInput.endDate.toDate(),
    };

    // return;
    setIsLoading(true);
    try {
      const res = await axios.post(`/subscription/assign-plan`, data, {
        withCredentials: true,
      });
      await Swal.fire({
        title: "Done!",
        text: res.data?.message,
        icon: "success",
        timer: 2000,
        confirmButtonText: "OK",
      });
      // getBusiness();
      // setAssignPlanInput(defaultState);
      navigate("/subscription-summary");
    } catch (error) {
      flare.report(error);
      Swal.fire({
        title: "",
        text: error.response?.data?.message || "Something went wrong",
        icon: "error",
        timer: 2000,
        confirmButtonText: "OK",
      });
    }
    setIsLoading(false);
  };

  const handleSubmitEx = async (e) => {
    e.preventDefault();
    Swal.fire({
      title: "Are you sure?",
      text: "This action will change the subscription plan information for this business.",
      showCancelButton: true,
      confirmButtonText: "Confirm",
    }).then((result) => {
      if (result.isConfirmed) {
        onUpdateCustomerPlan();
      }
    });
  };
  // console.log(assignPlanInput);
  const hasPlan = businessList?.find((us) => us._id === assignPlanInput?.business)?.plan;
  // console.log(hasPlan);
  useEffect(() => {
    if (hasPlan) {
      setAssignPlanInput({
        ...assignPlanInput,
        duration: hasPlan.duration,
        startDate: dayjs(new Date(hasPlan.startDate)),
        smsNotificationType: hasPlan.smsNotificationType,
        smsCount: hasPlan.smsCount,
        plan: hasPlan.plan,
      });
    } else {
      setAssignPlanInput({
        ...assignPlanInput,
        duration: "",
        startDate: "",
        endDate: "",
        smsNotificationType: "",
        smsCount: "",
        plan: "",
      });
    }
  }, [hasPlan]);

  useEffect(() => {
    if (assignPlanInput?.startDate && assignPlanInput?.duration) {
      setAssignPlanInput({ ...assignPlanInput, endDate: getEndDate(assignPlanInput) });
    }
  }, [assignPlanInput?.startDate, assignPlanInput?.duration]);

  useEffect(() => {
    if (searchParams.get("b")) {
      setAssignPlanInput({ ...assignPlanInput, business: searchParams.get("b") });
    }
  }, [searchParams]);

  useEffect(() => {
    document.title = appConfig.name + " - Recipient List";
    getBusiness();
    getPlan();
  }, []);
  const isEditing = searchParams.get("b");
  return (
    <Spin spinning={isLoading}>
      <div className="az-content-body p-0 px-md-3">
        <div className="row row-sm mg-b-15 mg-sm-b-20">
          <div className="col-md-12">
            <div className="card p-3 mb-3 card-dashboard-six">
              <div className="d-flex flex-column flex-md-row g-3 align-items-md-center mb-3">
                <div className="">
                  <label className="az-content-label">Manage Subscription Plan</label>
                  <span className="d-block py-2">Assign Subscription Plans</span>
                </div>
                <div className="ms-md-auto p-0">
                  <Link to="/subscription-summary" className="btn btn-secondary">
                    Back
                  </Link>
                </div>
              </div>
              <hr className="mt-0" />
              <div className="row mt-2">
                <div className="col-md-12">
                  <h5 className="pb-2">Select Business</h5>
                  <form onSubmit={handleSubmitEx}>
                    <div className="row">
                      <div className="col-md-6">
                        <CommonSelect
                          required
                          disabled={isEditing}
                          label="Business"
                          placeholder="Select Business"
                          isLoading={isBusinessLoading}
                          value={assignPlanInput.business}
                          onChange={(value) => {
                            onInputChange({
                              target: { name: "business", value },
                            });
                          }}
                          options={businessList}
                        />
                        <p
                          style={{
                            color: "red",
                            marginBottom: 0,
                            marginTop: "2px",
                            visibility: hasPlan?._id && !isEditing ? "visible" : "hidden",
                          }}
                        >
                          Warning: This business is already assigned to an existing subscription plan.
                        </p>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <h6>Select Subscription Plan</h6>
                      <div className="col-md-6">
                        <CommonSelect
                          required
                          label="Plan Name"
                          placeholder="Select Plan"
                          isLoading={isBusinessLoading}
                          value={assignPlanInput.plan}
                          onChange={(value) => {
                            onInputChange({
                              target: { name: "plan", value },
                            });
                          }}
                          options={plans}
                        />
                      </div>
                    </div>
                    <div className="row mt-4">
                      <h6>Plan Options</h6>

                      <div className="col-md-6">
                        <CommonSelect
                          required
                          label="Plan Duration"
                          placeholder="Select Plan Duration"
                          value={assignPlanInput.duration}
                          onChange={(value) => {
                            onInputChange({
                              target: { name: "duration", value },
                            });
                          }}
                          options={[
                            { _id: "1 Month", name: "1 Month" },
                            { _id: "3 Months", name: "3 Months" },
                            { _id: "6 Months", name: "6 Months" },
                            { _id: "1 Year", name: "1 Year" },
                            { _id: "2 Years", name: "2 Years" },
                            { _id: "5 Years", name: "5 Years" },
                            { _id: "10 Years", name: "10 Years" },
                            { _id: "20 Years", name: "20 Years" },
                          ]}
                        />
                      </div>
                      <div className="col-md-6">
                        {isEditing && (
                          <button
                            style={{ marginTop: "30px" }}
                            className="btn btn-success"
                            disabled={
                              !assignPlanInput.duration || !assignPlanInput.startDate || !assignPlanInput.endDate
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              setAssignPlanInput({ ...assignPlanInput, endDate: getEndDate(assignPlanInput, true) });
                            }}
                          >
                            Renew
                          </button>
                        )}
                      </div>
                      <div className="col-md-6 mt-2">
                        <label className="form-label">
                          Start Date <sub style={{ color: "red" }}>*</sub>
                        </label>
                        <DatePicker
                          placeholder="Select Start Date"
                          format={"DD/MM/YYYY"}
                          onChange={(value) => {
                            onInputChange({
                              target: { name: "startDate", value },
                            });
                          }}
                          value={assignPlanInput?.startDate ? assignPlanInput.startDate : ""}
                          disabledDate={(current) => current && current.valueOf() < new Date()}
                          size="large"
                          className="w-100"
                          getPopupContainer={(triggerNode) => triggerNode}
                        />
                      </div>
                      <div className="col-md-6 mt-2">
                        <label className="form-label">End Date</label>
                        <DatePicker
                          placeholder="End Date Will Set Based On Start Date And Plan Duration"
                          format={"DD/MM/YYYY"}
                          disabled
                          onChange={(value) => {
                            onInputChange({
                              target: { name: "endDate", value },
                            });
                          }}
                          value={assignPlanInput?.endDate ? assignPlanInput.endDate : ""}
                          disabledDate={(current) => current && current.valueOf() < new Date()}
                          size="large"
                          className="w-100 colored-disabled"
                          getPopupContainer={(triggerNode) => triggerNode}
                        />
                      </div>
                      <div className="col-md-6 d-flex mt-2">
                        {/* <div className="d-flex"></div> */}
                        <div style={{ width: "-webkit-fill-available" }}>
                          <CommonSelect
                            required
                            label="SMS Notification Type"
                            placeholder="Select SMS Notification Type"
                            value={assignPlanInput.smsNotificationType}
                            onChange={(value) => {
                              onInputChange({
                                target: { name: "smsNotificationType", value },
                              });
                            }}
                            options={[
                              { _id: "Yes", name: "Yes" },
                              { _id: "No", name: "No" },
                            ]}
                          />
                        </div>
                        <div style={{ width: "45%", marginLeft: "10px" }}>
                          <label className="form-label" style={{ visibility: "hidden" }}>
                            label
                          </label>
                          <input
                            name="smsCount"
                            value={assignPlanInput.smsCount}
                            onChange={onNumberInputChange}
                            className="form-control"
                            placeholder="Enter SMS Quantity"
                            disabled={assignPlanInput?.smsNotificationType === "No"}
                          />
                        </div>
                      </div>
                      <div className="col-md-12 mt-3 text-right">
                        <div className="d-flex align-items-center justify-content-end gap-2 pt-2">
                          <Button type="primary" htmlType="submit">
                            {!hasPlan?._id ? " Assign Plan" : "Save"}
                          </Button>
                          <Button
                            type="primary"
                            className="bg-secondary"
                            onClick={() => navigate("/subscription-summary")}
                            htmlType="button"
                          >
                            Cancel
                          </Button>
                        </div>
                        {/* <button type="submit" className="btn btn-success mt-4" disabled={isDisable}>
                          {!hasPlan?._id ? " Assign Plan" : "Save"}
                        </button>
                        <button
                          type="button"
                          className="btn btn-secondary mt-4 ml-2"
                          onClick={() => navigate("/subscription-summary")}
                        >
                          Cancel
                        </button> */}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              {/* <hr /> */}

              {/* <PrepaidPlanListTable
              data={assignedPlanEx}
              getAssignedPlan={getAssignedPlan}
            /> */}
            </div>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default AssigPlan;

const getEndDate = ({ duration, startDate, endDate }, isRenew) => {
  if (isRenew) {
    startDate = endDate;
  }
  switch (duration) {
    case "1 Month":
      return startDate.add(1, "month");
    case "3 Months":
      return startDate.add(3, "month");
    case "6 Months":
      return startDate.add(6, "month");
    case "1 Year":
      return startDate.add(1, "year");
    case "2 Years":
      return startDate.add(2, "year");
    case "5 Years":
      return startDate.add(5, "year");
    case "10 Years":
      return startDate.add(10, "year");
    case "20 Years":
      return startDate.add(20, "year");
    default:
      break;
  }
};

const defaultState = {
  duration: "",
  startDate: "",
  endDate: "",
  smsNotificationType: "",
  smsCount: "",
  // emailNotificationType: "",
  // paymentInterval: "",
  business: "",
  plan: "",
};
